/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { useState } from "react";

import { useHistory } from "react-router";

import { ApplicationTabs } from "Constants/ApplicationConstants";
import { ProfileTabs } from "Constants/ProfileConstants";

/**
 * Hook to manage the selected tab on a profile page.
 */
export const useProfileTabs = (): {
  selectedTab: ProfileTabs;
  setSelectedTab: (tab: ProfileTabs) => void;
} => {
  const history = useHistory();
  const tab = new URLSearchParams(location.search).get("tab");
  const [selectedTab, setSelectedTabName] = useState<ProfileTabs>(
    (tab as ProfileTabs) || ProfileTabs.Profile
  );

  const setSelectedTab = (tab: ProfileTabs): void => {
    setSelectedTabName(tab);
    history.replace({ search: `tab=${tab}` });
  };

  return { selectedTab, setSelectedTab };
};

/**
 * Hook to manage the selected tab on a application page.
 */
export const useApplicationTabs = (): {
  selectedTab: ApplicationTabs;
  setSelectedTab: (tab: ApplicationTabs) => void;
} => {
  const history = useHistory();
  const tab = new URLSearchParams(location.search).get("tab");
  const [selectedTab, setSelectedTabName] = useState<ApplicationTabs>(
    (tab as ApplicationTabs) || ApplicationTabs.ProfileInformation
  );

  const setSelectedTab = (tab: ApplicationTabs): void => {
    setSelectedTabName(tab);
    history.replace({ search: `tab=${tab}` });
  };

  return { selectedTab, setSelectedTab };
};
